module.exports = __webpack_public_path__ + "img/newIndex.4530d062.png";